"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../helpers/customPropTypes");

var _getTextFromNode = require("../helpers/getTextFromNode");

var _getTextFromNode2 = _interopRequireDefault(_getTextFromNode);

var _RawButton = require("../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

require("./Button.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconSize = {
  small: 11,
  medium: 14,
  large: 18
};

var Button = function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getClasses = function () {
      return (0, _classnames2.default)(_this.props.className, "aclui-button", "aclui-button--" + _this.props.type, "aclui-button--" + _this.props.size, { "aclui-button--is-active": _this.props.isActive }, { "is-disabled": _this.props.isDisabled }, { "aclui-button--is-dropdown": _this.props.isDropdown }, { "aclui-button--is-full-width": _this.props.isFullWidth }, { "aclui-button--is-pending": _this.props.isPending }, { "aclui-button--is-square": _this.props.isSquare || _this.props.isCloseButton }, { "aclui-button--is-close-button": _this.props.isCloseButton }, { "aclui-button--minor": _this.props.isCloseButton });
    }, _this.getAria = function () {
      if (_this.props.ariaLabel) return _this.props.ariaLabel;
      if (_this.props.isCloseButton) return "Close"; // TODO: use <i18nSync>
      return (0, _getTextFromNode2.default)(_react2.default.createElement(
        "span",
        null,
        _this.props.children
      )) || "Button"; // TODO: use <i18nSync>
    }, _this.handleClick = function (event) {
      return !_this.props.isDisabled && _this.props.onClick(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: "renderDropdownIcon",
    value: function renderDropdownIcon() {
      if (!this.props.isDropdown) return null;

      return this.props.isActive ? _react2.default.createElement(_Icon2.default, { type: "caret-up", size: iconSize[this.props.size], className: "aclui-button__dropdown-icon" }) : _react2.default.createElement(_Icon2.default, { type: "caret-down", size: iconSize[this.props.size], className: "aclui-button__dropdown-icon" });
    }
  }, {
    key: "renderPendingIcon",
    value: function renderPendingIcon() {
      if (!this.props.isPending) return null;
      return _react2.default.createElement(_Icon2.default, { type: "refresh", size: iconSize[this.props.size], className: "acl-i-spin" });
    }
  }, {
    key: "renderPropIcon",
    value: function renderPropIcon() {
      if (!this.props.icon && !this.props.isCloseButton || this.props.isPending) {
        return null;
      }
      if (this.props.isCloseButton) {
        var size = this.props.size === "small" ? iconSize.medium : iconSize.large;
        return _react2.default.createElement(_Icon2.default, { type: "times", size: size, className: "aclui-button__icon" });
      }
      return _react2.default.createElement(_Icon2.default, { type: this.props.icon, size: iconSize[this.props.size], className: "aclui-button__icon" });
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      /* Destructuring is used to isolate additional props in moreProps and pass them along to
         RawButton.  Several are used by getClasses() but not by render() – they must remain in
         this statement though to exclude them from moreProps.
      */
      var _props = this.props,
          ariaLabel = _props.ariaLabel,
          children = _props.children,
          className = _props.className,
          isActive = _props.isActive,
          isCloseButton = _props.isCloseButton,
          isDisabled = _props.isDisabled,
          isDropdown = _props.isDropdown,
          isFullWidth = _props.isFullWidth,
          isPending = _props.isPending,
          isSquare = _props.isSquare,
          size = _props.size,
          type = _props.type,
          moreProps = _objectWithoutProperties(_props, ["ariaLabel", "children", "className", "isActive", "isCloseButton", "isDisabled", "isDropdown", "isFullWidth", "isPending", "isSquare", "size", "type"]);
      /* eslint-enable no-unused-vars */

      return _react2.default.createElement(
        _RawButton2.default,
        _extends({
          ariaLabel: this.getAria(),
          className: this.getClasses(),
          isDisabled: isDisabled,
          onClick: this.handleClick
        }, moreProps),
        this.renderPendingIcon(),
        this.renderPropIcon(),
        _react2.default.createElement(
          "span",
          { className: "aclui-button__body" },
          children
        ),
        this.renderDropdownIcon()
      );
    }
  }]);

  return Button;
}(_react.PureComponent);

Button.propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  ariaLabel: _propTypes2.default.string,

  /** Reference to the RawButton Reaction element. */
  buttonRef: _propTypes2.default.func,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes2.default.bool,

  /** Body content of button. */
  children: _propTypes2.default.node,

  /** Additional classes to be included on the root element. */
  className: _propTypes2.default.string,

  /** The name of the ACL icon to be included in front of any content provided by children. */
  icon: _propTypes2.default.string,

  /** If the button is in an "active" or "selected" state. */
  isActive: _propTypes2.default.bool,

  /** If the button is a typical close button (with an "x"). */
  isCloseButton: _propTypes2.default.bool,

  /** If the button is disabled. */
  isDisabled: _propTypes2.default.bool,

  /** If the button includes a down arrow after any content provided by children. */
  isDropdown: _propTypes2.default.bool,

  /** If the width of the button should span it's parent container (100%). */
  isFullWidth: _propTypes2.default.bool,

  /** If the button should render in a pending state (with a spinner icon). */
  isPending: _propTypes2.default.bool,

  /** If the button is a fixed width square shape (for icon buttons). */
  isSquare: _propTypes2.default.bool,

  /** Callback to be executed when button is clicked or activated by keyboard. */
  onClick: _propTypes2.default.func.isRequired,

  /** Size of the button (font, min-height, padding, etc). */
  size: _customPropTypes.shirtSize,

  /** Value for tab-index to override the default of 0. */
  tabIndex: _propTypes2.default.number,

  /** The type or style of the button. */
  type: _propTypes2.default.oneOf(["default", "primary", "secondary", "destructive", "flat", "minor", "link"])
};

Button.defaultProps = {
  ariaLabel: "",
  buttonRef: function buttonRef() {},
  canPropagate: false,
  className: "",
  isActive: false,
  isCloseButton: false,
  isDisabled: false,
  isDropdown: false,
  isFullWidth: false,
  isPending: false,
  isSquare: false,
  size: "medium",
  type: "default",
  tabIndex: 0
};

exports.default = Button;